import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "audios-page" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "sidebar" }
const _hoisted_4 = { class: "nav-card" }
const _hoisted_5 = { class: "nav-logo" }
const _hoisted_6 = { class: "logo-icon" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "nav-list" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  class: "nav-menu-visual",
  "aria-hidden": "true"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "mobile-topbar-title" }
const _hoisted_13 = { class: "page-header" }
const _hoisted_14 = {
  class: "audio-tabs",
  "aria-label": "音频分类"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "audio-skeleton-row"
}
const _hoisted_17 = { class: "audio-skeleton-copy" }
const _hoisted_18 = { class: "audio-skeleton-meta" }
const _hoisted_19 = {
  key: 1,
  class: "audio-skeleton-row saved-audio-skeleton-row"
}
const _hoisted_20 = { class: "saved-audio-skeleton-copy" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "audio-cover-frame" }
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = { class: "audio-item-copy" }
const _hoisted_25 = { class: "audio-title" }
const _hoisted_26 = { class: "audio-subtitle" }
const _hoisted_27 = { class: "audio-meta" }
const _hoisted_28 = { class: "audio-kind" }
const _hoisted_29 = { class: "saved-audio-icon" }
const _hoisted_30 = { class: "saved-audio-copy" }
const _hoisted_31 = { class: "saved-audio-title" }
const _hoisted_32 = { class: "saved-audio-date" }
const _hoisted_33 = ["disabled", "aria-label", "onClick"]
const _hoisted_34 = {
  key: 1,
  class: "audio-page-loading"
}
const _hoisted_35 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_36 = {
  key: 0,
  class: "audios-player-dock",
  "aria-label": "音频播放器"
}
const _hoisted_37 = { class: "audios-player-copy" }
const _hoisted_38 = { class: "audios-player-title" }
const _hoisted_39 = ["src"]

import logo2Image from '../assets/logo2.png'
import menuBgImage from '../assets/menu_bg.jpg'
import ParentPasswordModal from '../components/ParentPasswordModal.vue'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getAudioSeriesPage, type AudioSeries } from '@/api/course-audio'
import { addFavorites, deleteFavorites, getFavoritesPage, type FavoritesVO } from '@/api/favorites'
import { addHistory, getHistoryPage, type HistoryVO } from '@/api/history'
import { getAccessToken } from '@/config/axios/auth'
import LoginPromptModal from '@/components/LoginPromptModal.vue'

const AUDIO_CONTENT_TYPE = 2

export default /*@__PURE__*/_defineComponent({
  __name: 'audios',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const routeStage = Array.isArray(route.query.stage) ? route.query.stage[0] : route.query.stage
const routeStageText = String(routeStage || '1')
const hasRouteStage = computed(() => routeStage != null && String(routeStage).trim() !== '')
const isGuestUser = computed(() => getAccessToken() == null)

const queryParams = ref({
  pageNo: 1,
  pageSize: 10,
  stage: routeStage
})

const audioSeriesList = ref<AudioSeries[]>([])
const favoriteAudioList = ref<FavoritesVO[]>([])
const historyAudioList = ref<HistoryVO[]>([])
const dataTotal = ref(0)
const isLoading = ref(false)
const activeNav = ref('')
const activeTab = ref('all')
const isLoginPromptOpen = ref(false)
const isTopbarScrolled = ref(false)
const favoriteLoadingIds = ref<number[]>([])
const favoriteStateOverrides = ref<Record<number, boolean>>({})
const currentAudioItemId = ref<number | string>('')
const currentAudioTitle = ref('')
const currentAudioSrc = ref('')
const audioPlayerRef = ref<HTMLAudioElement | null>(null)
const parentPasswordModalRef = ref(null)
const audioListRef = ref<HTMLElement | null>(null)
let audioScrollContainer: HTMLElement | null = null

const navItems = [
  { id: 'home', label: '首页', icon: 'home' },
  { id: 'history', label: '观看历史', icon: 'play-circle' },
  { id: 'favorites', label: '宝贝收藏', icon: 'heart' },
  { id: 'settings', label: '偏好设置', icon: 'cog' },
  { id: 'parent', label: '家长模式', icon: 'user-shield' },
]

const stageAgeRangeMap: Record<string, string> = {
  sense: '0-3岁',
  sprout: '3-6岁',
  expression: '6-9岁',
  ability: '9-12岁',
  1: '0-3岁',
  2: '3-6岁',
  3: '6-9岁',
  4: '9-12岁'
}

const mobilePageTitle = computed(() => {
  const title = typeof route.query.title === 'string' ? route.query.title.trim() : ''
  return title || '音频库'
})
const isAudioBookEntry = computed(() => mobilePageTitle.value.includes('有声书'))

const routeStageValues = computed(() => routeStageText.split(',').map((stage) => stage.trim()).filter(Boolean))
const isRouteStagePair = (stageValues: string[]) => {
  if (!hasRouteStage.value || routeStageValues.value.length !== stageValues.length) {
    return false
  }

  return stageValues.every((stage) => routeStageValues.value.includes(stage))
}
const isSongStageRoute = computed(() => isRouteStagePair(['1', '2']))
const isBookStageRoute = computed(() => isRouteStagePair(['3', '4']))

const tabs = computed(() => {
  if (isSongStageRoute.value) {
    return [
      { id: 'all', label: '全部' },
      { id: 'stage-1', label: '0-3' },
      { id: 'stage-2', label: '3-6' }
    ]
  }

  if (isBookStageRoute.value) {
    return [
      { id: 'all', label: '全部' },
      { id: 'stage-3', label: '6-9' },
      { id: 'stage-4', label: '9-12' }
    ]
  }

  if (!hasRouteStage.value) {
    if (isAudioBookEntry.value) {
      return [
        { id: 'all', label: '全部' },
        { id: 'stage-3', label: '6-9' },
        { id: 'stage-4', label: '9-12' }
      ]
    }

    return [
      { id: 'all', label: '全部' },
      { id: 'stage-1', label: '0-3' },
      { id: 'stage-2', label: '3-6' }
    ]
  }

  return [
    { id: 'all', label: '全部' },
    { id: 'favorites', label: '收藏' },
    { id: 'recent', label: '最近' }
  ]
})

const dataTotalPages = computed(() => Math.ceil(dataTotal.value / queryParams.value.pageSize))
const hasNextSeriesPage = computed(() => queryParams.value.pageNo < dataTotalPages.value)
const currentListLength = computed(() => {
  if (activeTab.value === 'favorites') {
    return favoriteAudioList.value.length
  }

  if (activeTab.value === 'recent') {
    return historyAudioList.value.length
  }

  return audioSeriesList.value.length
})
const showSeriesSkeleton = computed(() => isLoading.value && currentListLength.value === 0)
const isSeriesPageLoading = computed(() => isLoading.value && currentListLength.value > 0)
const isSeriesListTab = computed(() => !['favorites', 'recent'].includes(activeTab.value))

const visibleSeriesItems = computed(() => {
  if (activeTab.value === 'favorites') {
    return favoriteAudioList.value.map((item) => buildAudioListItem(item, 'favorite'))
  }

  if (activeTab.value === 'recent') {
    return historyAudioList.value.map((item) => buildAudioListItem(item, 'history'))
  }

  return audioSeriesList.value.map((item) => ({
    id: item.id,
    seriesId: item.id,
    title: item.chineseName || '音频课程',
    subtitle: item.englishName || item.description || 'Tree Sapling Audio',
    coverUrl: item.coverUrl || logo2Image,
    ageRanges: routeStageAgeRanges.value,
  }))
})

const buildAudioListItem = (item: FavoritesVO | HistoryVO, source: string) => ({
  id: item.contentId,
  source,
  seriesId: item.seriesId,
  title: item.chinese || item.name || '音频课程',
  subtitle: item.english || item.category || item.name || 'Tree Sapling Audio',
  coverUrl: item.coverUrl || logo2Image,
  audioUrl: item.audioUrl,
  date: item.createTime,
  isFavorite: getAudioFavoriteState(item, source),
  isFavoriteLoading: favoriteLoadingIds.value.includes(item.contentId),
  ageRanges: routeStageAgeRanges.value,
})

const getAudioFavoriteState = (item: FavoritesVO | HistoryVO, source: string) => {
  if (item.contentId in favoriteStateOverrides.value) {
    return favoriteStateOverrides.value[item.contentId]
  }

  return source === 'favorite' || item.isFavorite === 0
}

const setAudioFavoriteState = (audioId: number, isFavorite: boolean) => {
  favoriteStateOverrides.value = {
    ...favoriteStateOverrides.value,
    [audioId]: isFavorite
  }
}

const normalizeAgeRange = (value: string) => {
  const normalizedValue = value.trim()

  if (!normalizedValue) {
    return ''
  }

  return stageAgeRangeMap[normalizedValue] ||
    (normalizedValue.endsWith('岁') ? normalizedValue : `${normalizedValue}岁`)
}

const routeStageAgeRanges = computed(() => {
  if (activeTab.value === 'stage-1') {
    return ['0-3岁']
  }

  if (activeTab.value === 'stage-2') {
    return ['3-6岁']
  }

  if (activeTab.value === 'stage-3') {
    return ['6-9岁']
  }

  if (activeTab.value === 'stage-4') {
    return ['9-12岁']
  }

  if (!hasRouteStage.value) {
    if (activeTab.value === 'stage-1') {
      return ['0-3岁']
    }

    if (activeTab.value === 'stage-2') {
      return ['3-6岁']
    }

    if (activeTab.value === 'stage-3') {
      return ['6-9岁']
    }

    if (activeTab.value === 'stage-4') {
      return ['9-12岁']
    }

    if (isAudioBookEntry.value) {
      return ['6-9岁', '9-12岁']
    }

    return ['0-3岁', '3-6岁']
  }

  const ageRanges = routeStageText
    .split(',')
    .map(normalizeAgeRange)
    .filter(Boolean)

  return ageRanges.length ? ageRanges : ['0-3岁']
})

const handleAudioCoverError = (event: Event) => {
  const image = event.target as HTMLImageElement | null
  if (image && image.src !== logo2Image) {
    image.src = logo2Image
  }
}

const handleGoBack = () => {
  if (window.history.length > 1) {
    router.back()
    return
  }

  router.push('/category')
}

const openParentPasswordModal = () => {
  parentPasswordModalRef.value?.open()
}

const openLoginPrompt = () => {
  isLoginPromptOpen.value = true
}

const goLogin = () => {
  isLoginPromptOpen.value = false
  router.push('/login')
}

const handleNavItemClick = (item) => {
  if (item.id === 'home') {
    router.push('/')
    return
  }

  if (item.id === 'parent') {
    openParentPasswordModal()
    return
  }

  if (item.id === 'settings') {
    router.push('/preference')
    return
  }

  if (item.id === 'history' || item.id === 'favorites') {
    router.push({
      path: '/history',
      query: item.id === 'favorites' ? { tab: 'favorites' } : {}
    })
  }
}

const handleSeriesClick = (item) => {
  router.push({
    path: '/audio',
    query: {
      seriesId: item.seriesId || item.id,
      title: mobilePageTitle.value
    }
  })
}

const handleAudioItemClick = (item) => {
  if (isSeriesListTab.value) {
    handleSeriesClick(item)
    return
  }

  playAudioItem(item)
}

const playAudioItem = (item) => {
  if (!item.audioUrl) {
    return
  }

  currentAudioItemId.value = item.id
  currentAudioTitle.value = item.title
  currentAudioSrc.value = item.audioUrl

  if (!isGuestUser.value) {
    addHistory({ contentType: AUDIO_CONTENT_TYPE, contentId: item.id })
  }

  requestAnimationFrame(() => {
    if (!audioPlayerRef.value || !currentAudioSrc.value) {
      return
    }

    audioPlayerRef.value.currentTime = 0
    audioPlayerRef.value.play().catch(() => {})
  })
}

const handleAudioEnded = () => {
  currentAudioItemId.value = ''
  currentAudioTitle.value = ''
  currentAudioSrc.value = ''
}

const getStageForTab = (tabId: string) => {
  if (tabId === 'stage-1') {
    return '1'
  }

  if (tabId === 'stage-2') {
    return '2'
  }

  if (tabId === 'stage-3') {
    return '3'
  }

  if (tabId === 'stage-4') {
    return '4'
  }

  if (hasRouteStage.value) {
    return routeStage
  }

  return undefined
}

const selectTab = (tabId: string) => {
  if (activeTab.value === tabId) {
    return
  }

  if (['favorites', 'recent'].includes(tabId) && isGuestUser.value) {
    openLoginPrompt()
    return
  }

  activeTab.value = tabId
  queryParams.value.pageNo = 1
  queryParams.value.stage = getStageForTab(tabId)
  dataTotal.value = 0
  loadCurrentTabList()
}

const toggleFavorite = async (item) => {
  if (isGuestUser.value) {
    openLoginPrompt()
    return
  }

  const audioId = item.id
  if (!audioId || favoriteLoadingIds.value.includes(audioId)) {
    return
  }

  const wasFavorite = item.isFavorite === true
  const removedFavoriteItems = activeTab.value === 'favorites'
    ? favoriteAudioList.value.filter((favoriteItem) => favoriteItem.contentId === audioId)
    : []

  favoriteLoadingIds.value = [...favoriteLoadingIds.value, audioId]
  setAudioFavoriteState(audioId, !wasFavorite)

  if (wasFavorite && activeTab.value === 'favorites') {
    favoriteAudioList.value = favoriteAudioList.value.filter((favoriteItem) => favoriteItem.contentId !== audioId)
    dataTotal.value = Math.max(0, dataTotal.value - removedFavoriteItems.length)
  }

  try {
    if (wasFavorite) {
      await deleteFavorites(AUDIO_CONTENT_TYPE, audioId)
    } else {
      await addFavorites({
        contentType: AUDIO_CONTENT_TYPE,
        contentId: audioId
      })
    }
  } catch {
    setAudioFavoriteState(audioId, wasFavorite)
    if (removedFavoriteItems.length) {
      favoriteAudioList.value = [...removedFavoriteItems, ...favoriteAudioList.value]
      dataTotal.value += removedFavoriteItems.length
    }
  } finally {
    favoriteLoadingIds.value = favoriteLoadingIds.value.filter((id) => id !== audioId)
  }
}

const handlePageScroll = () => {
  isTopbarScrolled.value = window.scrollY > 2
  if (isPageNearBottom()) {
    loadNextSeriesPage()
  }
}

const isPageNearBottom = () => {
  const scrollContainer = audioListRef.value

  if (scrollContainer && scrollContainer.scrollHeight > scrollContainer.clientHeight + 1) {
    return scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight - 120
  }

  const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight
  const pageHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight)

  return scrollTop + viewportHeight >= pageHeight - 120
}

const loadNextSeriesPage = async () => {
  if (isLoading.value || !hasNextSeriesPage.value) {
    return
  }

  queryParams.value.pageNo += 1
  await loadCurrentTabList(true)
}

const loadCurrentTabList = async (append = false) => {
  if (activeTab.value === 'favorites') {
    await getFavoriteAudioList(append)
    return
  }

  if (activeTab.value === 'recent') {
    await getHistoryAudioList(append)
    return
  }

  await getAudioSeriesList(append)
}

const getAudioSeriesList = async (append = false) => {
  if (isLoading.value) {
    return
  }

  isLoading.value = true
  try {
    const params = { ...queryParams.value }
    if (params.stage == null || params.stage === '') {
      delete params.stage
    }

    const data = await getAudioSeriesPage(params)
    const list = data?.list || []
    audioSeriesList.value = append ? [...audioSeriesList.value, ...list] : list
    dataTotal.value = data?.total || 0
  } catch {
    if (append) {
      queryParams.value.pageNo = Math.max(1, queryParams.value.pageNo - 1)
    }
  } finally {
    isLoading.value = false
  }
}

const getFavoriteAudioList = async (append = false) => {
  if (isGuestUser.value) {
    openLoginPrompt()
    return
  }

  if (isLoading.value) {
    return
  }

  isLoading.value = true
  try {
    const data = await getFavoritesPage({
      ...queryParams.value,
      contentType: AUDIO_CONTENT_TYPE
    })
    const list = data?.list || []
    favoriteAudioList.value = append ? [...favoriteAudioList.value, ...list] : list
    dataTotal.value = data?.total || 0
  } catch {
    if (append) {
      queryParams.value.pageNo = Math.max(1, queryParams.value.pageNo - 1)
    }
  } finally {
    isLoading.value = false
  }
}

const getHistoryAudioList = async (append = false) => {
  if (isGuestUser.value) {
    openLoginPrompt()
    return
  }

  if (isLoading.value) {
    return
  }

  isLoading.value = true
  try {
    const data = await getHistoryPage({
      ...queryParams.value,
      contentType: AUDIO_CONTENT_TYPE
    })
    const list = data?.list || []
    historyAudioList.value = append ? [...historyAudioList.value, ...list] : list
    dataTotal.value = data?.total || 0
  } catch {
    if (append) {
      queryParams.value.pageNo = Math.max(1, queryParams.value.pageNo - 1)
    }
  } finally {
    isLoading.value = false
  }
}

onMounted(() => {
  loadCurrentTabList()
  audioScrollContainer = audioListRef.value
  window.addEventListener('scroll', handlePageScroll, { passive: true })
  audioScrollContainer?.addEventListener('scroll', handlePageScroll, { passive: true })
  handlePageScroll()
})

onUnmounted(() => {
  window.removeEventListener('scroll', handlePageScroll)
  audioScrollContainer?.removeEventListener('scroll', handlePageScroll)
  audioScrollContainer = null
})

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("aside", _hoisted_3, [
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _unref(logo2Image),
                alt: "",
                class: "logo2-icon"
              }, null, 8, _hoisted_7)
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "brand-copy" }, [
              _createElementVNode("h1", { class: "brand-name" }, "树苗英语"),
              _createElementVNode("span", { class: "brand-subtitle" }, "TREE SAPLING")
            ], -1))
          ]),
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
              return _createElementVNode("li", {
                key: item.id
              }, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _withModifiers(($event: any) => (handleNavItemClick(item)), ["prevent"]),
                  class: _normalizeClass(['nav-item', { active: activeNav.value === item.id }])
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: item.icon,
                    class: "nav-icon"
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", null, _toDisplayString(item.label), 1)
                ], 10, _hoisted_9)
              ])
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              src: _unref(menuBgImage),
              alt: "",
              class: "nav-menu-image"
            }, null, 8, _hoisted_11)
          ])
        ])
      ]),
      _createElementVNode("main", {
        class: _normalizeClass(["audios-shell", { 'has-player': currentAudioTitle.value }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["mobile-topbar", { 'is-scrolled': isTopbarScrolled.value }])
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "mobile-back-btn",
            onClick: handleGoBack,
            "aria-label": "返回上一页"
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "chevron-left" })
          ]),
          _createElementVNode("h1", _hoisted_12, _toDisplayString(mobilePageTitle.value), 1),
          _cache[2] || (_cache[2] = _createElementVNode("span", {
            class: "mobile-topbar-spacer",
            "aria-hidden": "true"
          }, null, -1))
        ], 2),
        _cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "mobile-topbar-offset",
          "aria-hidden": "true"
        }, null, -1)),
        _createElementVNode("header", _hoisted_13, [
          _createElementVNode("button", {
            type: "button",
            class: "back-btn",
            onClick: handleGoBack,
            "aria-label": "返回上一页"
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "chevron-left" })
          ])
        ]),
        _createElementVNode("nav", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
            return (_openBlock(), _createElementBlock("button", {
              key: tab.id,
              type: "button",
              class: _normalizeClass(["audio-tab", { active: activeTab.value === tab.id }]),
              onClick: ($event: any) => (selectTab(tab.id))
            }, _toDisplayString(tab.label), 11, _hoisted_15))
          }), 128))
        ]),
        _createElementVNode("section", {
          ref_key: "audioListRef",
          ref: audioListRef,
          class: _normalizeClass(["audio-list", {
            'all-list-frame': isSeriesListTab.value,
            'saved-list-frame': !isSeriesListTab.value
          }]),
          "aria-label": "音频系列列表"
        }, [
          (showSeriesSkeleton.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(queryParams.value.pageSize, (index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `audio-series-skeleton-${index}`,
                  class: "audio-item audio-skeleton-item"
                }, [
                  _createVNode(_component_el_skeleton, { animated: "" }, {
                    template: _withCtx(() => [
                      (isSeriesListTab.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createVNode(_component_el_skeleton_item, {
                              variant: "image",
                              class: "audio-skeleton-cover"
                            }),
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_el_skeleton_item, {
                                variant: "text",
                                class: "audio-skeleton-title"
                              }),
                              _createVNode(_component_el_skeleton_item, {
                                variant: "text",
                                class: "audio-skeleton-subtitle"
                              }),
                              _createElementVNode("div", _hoisted_18, [
                                _createVNode(_component_el_skeleton_item, {
                                  variant: "button",
                                  class: "audio-skeleton-badge"
                                }),
                                _createVNode(_component_el_skeleton_item, {
                                  variant: "text",
                                  class: "audio-skeleton-kind"
                                })
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createVNode(_component_el_skeleton_item, {
                              variant: "circle",
                              class: "saved-audio-skeleton-icon"
                            }),
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_el_skeleton_item, {
                                variant: "text",
                                class: "saved-audio-skeleton-title"
                              }),
                              _createVNode(_component_el_skeleton_item, {
                                variant: "text",
                                class: "saved-audio-skeleton-date"
                              })
                            ]),
                            _createVNode(_component_el_skeleton_item, {
                              variant: "button",
                              class: "saved-audio-skeleton-button"
                            })
                          ]))
                    ]),
                    _: 1
                  })
                ]))
              }), 128))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleSeriesItems.value, (item) => {
            return _withDirectives((_openBlock(), _createElementBlock("article", {
              key: item.id,
              class: _normalizeClass(["audio-item", { playing: currentAudioItemId.value === item.id }]),
              onClick: ($event: any) => (handleAudioItemClick(item))
            }, [
              (isSeriesListTab.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("img", {
                        src: item.coverUrl,
                        alt: item.title,
                        class: "audio-cover",
                        onError: handleAudioCoverError
                      }, null, 40, _hoisted_23)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("h2", _hoisted_25, _toDisplayString(item.title), 1),
                      _createElementVNode("p", _hoisted_26, _toDisplayString(item.subtitle), 1),
                      _createElementVNode("div", _hoisted_27, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.ageRanges, (ageRange) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: `${item.id}-${ageRange}`,
                            class: "audio-age-badge"
                          }, _toDisplayString(ageRange), 1))
                        }), 128)),
                        _createElementVNode("span", _hoisted_28, [
                          _createVNode(_component_font_awesome_icon, { icon: "headphones" }),
                          _cache[3] || (_cache[3] = _createTextVNode(" 音频 ", -1))
                        ])
                      ])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: currentAudioItemId.value === item.id ? 'volume-high' : 'headphones'
                      }, null, 8, ["icon"])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("h2", _hoisted_31, _toDisplayString(item.title), 1),
                      _createElementVNode("p", _hoisted_32, _toDisplayString(item.date), 1)
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["saved-favorite-btn", { active: item.isFavorite }]),
                      disabled: item.isFavoriteLoading,
                      "aria-label": item.isFavorite ? '取消收藏' : '收藏',
                      onClick: _withModifiers(($event: any) => (toggleFavorite(item)), ["stop"])
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: item.isFavorite ? 'heart-circle-check' : 'heart'
                      }, null, 8, ["icon"]),
                      _createElementVNode("span", null, _toDisplayString(item.isFavorite ? '已收藏' : '收藏'), 1)
                    ], 10, _hoisted_33)
                  ], 64))
            ], 10, _hoisted_21)), [
              [_vShow, !showSeriesSkeleton.value]
            ])
          }), 128)),
          (isSeriesPageLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createVNode(_component_el_skeleton, { animated: "" }, {
                  template: _withCtx(() => [
                    _createVNode(_component_el_skeleton_item, {
                      variant: "text",
                      class: "audio-page-loading-line"
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (!showSeriesSkeleton.value && visibleSeriesItems.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createVNode(_component_font_awesome_icon, { icon: "headphones" }),
                _cache[4] || (_cache[4] = _createElementVNode("p", null, "没有音频内容", -1))
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _createVNode(_Transition, { name: "player-dock" }, {
          default: _withCtx(() => [
            (currentAudioTitle.value)
              ? (_openBlock(), _createElementBlock("section", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "audios-player-label" }, "正在播放", -1)),
                    _createElementVNode("strong", _hoisted_38, _toDisplayString(currentAudioTitle.value), 1)
                  ]),
                  _createElementVNode("audio", {
                    ref_key: "audioPlayerRef",
                    ref: audioPlayerRef,
                    class: "audios-player",
                    src: currentAudioSrc.value,
                    controls: "",
                    preload: "metadata",
                    onEnded: handleAudioEnded
                  }, null, 40, _hoisted_39)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2)
    ]),
    _createVNode(ParentPasswordModal, {
      ref_key: "parentPasswordModalRef",
      ref: parentPasswordModalRef
    }, null, 512),
    _createVNode(LoginPromptModal, {
      modelValue: isLoginPromptOpen.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isLoginPromptOpen).value = $event)),
      onConfirm: goLogin
    }, null, 8, ["modelValue"])
  ]))
}
}

})